import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetDefaultRolesAction = function () {

}

GetDefaultRolesAction.prototype = {

	// GET getDefaultRoles?domainName=… — default roles for the Roles & access tab.
	// Settles a promise so the caller can fall back to the seed roles on failure.
	getDefaultRoles: function (domainName) {
		return new Promise((resolve, reject) => {
			restClient.getDefaultRoles(domainName, function (error, response) {
				if (error || response == null) {
					if (error && error.status === 401) {
						AppDispatcher.dispatch({
							actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
							data: error
						});
					}
					reject(error);
				} else {
					resolve(response);
				}
			})
		});
	}
}

export default new GetDefaultRolesAction();
